<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <div v-if="$store.getters.marchand || $store.getters.isAdmin"  class="row">
        <div class="col-12 mb-4">
            <div class="mt-3">
            <v-alert type="info">
              {{ $t('reversements.historiesdescription') }}
            </v-alert>
          </div>
            <v-card>
                <div class="col-12 pt-0 pb-0 mt-0 mb-0" style="background: #fff">
                    <div class="col-12">
                     <div class="row">
                            <div class="col-6 p-0">
                               <h5 style="font-weight:200">{{$t('reversements.list_reversement')}}</h5>
                            </div>
                         <div class="col-6 p-0 text-right">
                                <v-btn @click="goToConfigs" small class="mb-0">
                                    {{$t('reversements.configs')}}
                                </v-btn>
                            </div>
                        </div>
                        </div>
                </div>
                <v-data-table
                        :headers="(!this.$store.getters.marchand)?headers:headersMarchand"
                        :items="reversements"
                        :search="search"
                        sort-by="name"
                        class="elevation-1"
                        :loading="!reversements" loading-text="Chargement en cours...">
                    <template v-slot:item._account_name="{ item }">
                       {{item._config._usermeanspaiement._account_name+' '+ item._config._usermeanspaiement._account_surname}}
                    </template>
                    <template v-slot:item._account_number="{ item }">
                        <v-chip class="ma-2" style="padding: 15px" :color="(item._config._usermeanspaiement._means_paiement._type==='Mobile')?'orange':'green'" text-color="white">
                            <v-avatar left>
                                <v-icon>{{(item._config._usermeanspaiement._means_paiement._type!=='Mobile')?'mdi-bank':'mdi-cellphone-android'}}</v-icon>
                            </v-avatar>
                            {{item._config._usermeanspaiement._account_number}}
                        </v-chip>
                        <!--{{item._config._usermeanspaiement._account_number+' ('+item._config._usermeanspaiement._means_paiement._type +')'}}-->
                    </template>
                    <template v-slot:item._montant_recu="{ item }">
                        {{formatAmount(item._montant_recu) +' '+item.x_currency._code_alpha}}
                    </template>
                    <template v-slot:item._montant_frais="{ item }">
                        {{formatAmount(item._montant_frais) +' '+item.x_currency._code_alpha}}
                    </template>
                    <template v-if="!this.$store.getters.marchand" v-slot:item._marchand="{ item }">
                        <router-link  style="text-decoration: none"  :to="{name:'marchand.details',params: { id: item._marchand._id}}">
                        {{item._marchand._company}}
                        </router-link>
                    </template>

                    <template v-slot:item._created_at="{ item }">
                        {{getDate(item._created_at)}}
                    </template>
                    <template v-slot:no-data>
                        {{$t('no_data')}}
                    </template>
                </v-data-table>
            </v-card>
        </div>
    </div>
    <div  v-else>
        <go-to-params></go-to-params>
    </div>
</template>

<script>
    /* eslint-disable */
    import {mapState} from "vuex";
    import * as Swal from "sweetalert2";
    import CountryFlag from 'vue-country-flag'
    import helpers from "../../../../mixins/helpers";
    import countries from '../../../../resources/countries.json'
    import $ from 'jquery'
    import GoToParams from "../../globalComponents/GoToParams";
    export default {
        components: {
            GoToParams,
            CountryFlag
        },
        mixins:[helpers(this)],
        label: "Reversements",
        data() {
            return {
                submitting: false,
                valid: true,
                lazy: false,
                search: '',
                dialog: false,
                 note:"",
                id: undefined,
                errors:undefined,
                headers: [
                    {
                        text: 'Compte',
                        align: 'start',
                        sortable: true,
                        value: '_account_name',
                    },
                    {text: 'Numéro du compte', value: '_account_number'},
                    {text: 'Marchand', value: '_marchand'},
                    {text: 'Montant', value: '_montant_recu'},
                    {text: 'Taux', value: '_rate'},
                    {text: 'Frais', value: '_montant_frais'},
                    {text: 'Date', value: '_created_at'},
                ],
                headersMarchand: [
                    {
                        text: 'Compte',
                        align: 'start',
                        sortable: true,
                        value: '_account_name',
                    },
                    {text: 'Numéro du compte', value: '_account_number'},
                    {text: 'Montant', value: '_montant_recu'},
                    {text: 'Taux', value: '_rate'},
                    {text: 'Frais', value: '_montant_frais'},
                    {text: 'Date', value: '_created_at'},
                ],


            }
        }
        ,
        computed: {
            ...mapState('reversements/', ['reversements']),

        },
        mounted() {
            let role = (this.$store.getters.marchand)?"marchand":"admin";
            this.$store.dispatch('reversements/getReversements', role).then(response => {
                window.console.log('reversements ==> ', response)
            });
            this.changeHeaderName(this.$t('menus.reversements'))

        }
        ,
        watch: {
            dialog(val) {
                val || this.close()
            },
        }
        ,
        methods: {
            initialize() {

            },
            goToConfigs(){
                let url = (this.$store.getters.marchand)?'reversements.configs':'adminreversements.configs';
                this.$router.push({name:url});
            }


        },

        created() {
            this.checkisDashboard();
            this.initialize()
        },

    }
</script>

<style scoped>

</style>
